import { useQuery } from "@tanstack/react-query";
import { getPreReleaseClients } from "../api/real-cookie-banner.js";
import { useStores } from "../store/root.js";
import { QueryKeys } from "../util/query-keys.js";
function usePreReleaseClients(clientUuid = undefined, enabled = undefined) {
    const { rcbAuthenticationStore } = useStores();
    const preReleaseClientsQuery = useQuery(QueryKeys.getPreReleaseClients(enabled, clientUuid), ({ signal })=>{
        const urlParameter = {};
        if (enabled !== undefined) {
            urlParameter.enabled = enabled;
        }
        if (clientUuid !== undefined) {
            urlParameter.clientUuid = clientUuid;
        }
        return getPreReleaseClients({
            params: urlParameter,
            signal,
            headers: {
                Authorization: `Bearer ${rcbAuthenticationStore?.session?.jwt}`
            }
        });
    });
    return preReleaseClientsQuery;
}
export { usePreReleaseClients };
